<template>
<div>
  <v-container fluid class="align-center px-5">
    <v-card flat class="intro-body align-center justify-center pt-0" :class="cardClass()">
      <v-card-text class="py-1 px-0 overflow-auto">
        <mrx-translation class="white--text mb-4" token="questions.geo_permission.message"></mrx-translation>
        <v-btn block x-large class="mb-4 px-0" @click="askForGeo()" :id="'ask-for-geo'" >
          <v-progress-circular v-if="loading" indeterminate color="white" size=30 class="me-2"></v-progress-circular>
          <v-icon v-if="finished" size=30 :color="this.iconBackground" left>{{icon}}</v-icon>
          <mrx-translation :renderAsHTML="true" :token="buttonToken"></mrx-translation>
        </v-btn>
        <mrx-translation class="white--text pb-4" :token="finishMessage"></mrx-translation>
      </v-card-text>
    </v-card>
  </v-container>
</div>
</template>

<script>
  import languageLogic from '@/mixins/languageLogic'
  import icons from '@/mixins/icons'
  import ui from '@/mixins/ui'

  export default {
    mixins: [languageLogic, icons, ui],
    name: 'geolocation',
    model: {
      prop: 'items',
      event: 'click'
    },
    data() {
      return {
        stepper: 1,
        geoError: true,
        icon: null,
        iconText: 'responses.geo_permission.message.searching.title',
        iconBackground: 'grey',
        iconColor: 'white',
        finished: false,
        loading: false,
        finishMessage: ''
      }
    },

    props: {
      items: Array,
      options: Object,
      languagePath: String,
      panelName: String
    },

    methods: {
      async askForGeo() {
        // do not repeat check if already complete
        if (this.finished) {
          return
        }

        this.loading = true
        this.geoError = true
        this.stepper = 2
        let positionFetchSuccess = await this.$store.dispatch('v4/geo/getPosition')

        if (positionFetchSuccess) {
          this.icon = this.icons.mdiCheckCircle
          this.iconBackground = 'success'
          this.items[0].value = 'granted'
          this.items[0].selected = true
          this.$track(this.$analyticsEvents.GEOLOCATION_GRANTED, {
            component: 'GeoLocation',
            panel_name: this.panelName
          })
        }
        else {
          this.icon = this.icons.mdiAlertCircle
          this.finishMessage = `responses.geo_permission.message.error.instructions`
          this.iconBackground = 'danger'
          this.items[0].value = 'denied'
          this.items[0].selected = true
          this.$track(this.$analyticsEvents.GEOLOCATION_DENIED, {
            component: 'GeoLocation',
            panel_name: this.panelName
          })
        }
        this.finished = true
        this.loading = false
        this.iconText = `responses.geo_permission.message.${this.items[0].value}.title`
      }
    },
    computed: {
      buttonToken() {
        if (this.finished || this.loading) {
          return this.iconText
        } else {
          return `questions.geo_permission.grant_access`
        }
      }
    }
  }
</script>
